import * as React from "react";
const SvgArrowDoubleUp20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m16.707 9.293-6-6L10 2.586l-.707.707-6 6 1.414 1.414L10 5.414l5.293 5.293 1.414-1.414Zm0 6-6-6L10 8.586l-.707.707-6 6 1.414 1.414L10 11.414l5.293 5.293 1.414-1.414Z",
      clipRule: "evenodd"
    })
  );
export default SvgArrowDoubleUp20Px;
